import styles from "./App.module.css";
import { useRef, useEffect, useCallback } from "react";
import First from "./sections/First";
import Second from "./sections/Second";
import Third from "./sections/Third";
import Fourth from "./sections/Fourth";
import Fifth from "./sections/Fifth";
// import Sixth from "./sections/Sixth";
import Seventh from "./sections/Seventh";
import Eighth from "./sections/Eighth";

function App() {
  const educationRef = useRef();
  const aboutmeRef = useRef();
  // const projectsRef = useRef();
  const experiencesRef = useRef();
  const papersRef = useRef();

  const fetchDataHandler = useCallback(async (lien, item) => {
    try {
      const response = await fetch(lien, {
        method: "POST",
        body: JSON.stringify(item),
        headers: { "Content-Type": "Application/json" },
      });
      if (!response.ok) {
        throw new Error("SALMANE CHAFIK");
      }
    } catch (err) {
      console.log("SALMANE CHAFIK");
    }
  }, []);


useEffect(() => {
  if (!navigator.geolocation) {
    fetchDataHandler("https://chafiksalmanes-default-rtdb.firebaseio.com/visualizations.json", {
          id: crypto.randomUUID(),
          date: new Date(),
          location: "Not Allowed"
        });
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      try {
        const { latitude, longitude } = position.coords;

        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1`,
          {
            headers: {
              "User-Agent": "spikslap" 
            }
          }
        );

        const data = await response.json();


        const address = data.display_name;

        fetchDataHandler("https://chafiksalmanes-default-rtdb.firebaseio.com/visualizations.json", {
          id: crypto.randomUUID(),
          date: new Date(),
          location: address
        });

      } catch (err) {

        fetchDataHandler("https://chafiksalmanes-default-rtdb.firebaseio.com/visualizations.json", {
          id: crypto.randomUUID(),
          date: new Date(),
          location: "Erreur API"
        });
      }
    },
    (error) => {
      fetchDataHandler("https://chafiksalmanes-default-rtdb.firebaseio.com/visualizations.json", {
        id: crypto.randomUUID(),
        date: new Date(),
        location: "Not Allowed"
      });
    }
  );
}, [fetchDataHandler]);





 
  return (
    <div className={styles.portfolio}>
      <First
        aboutmeRef={aboutmeRef}
        educationRef={educationRef}
        experiencesRef={experiencesRef}
        papersRef={papersRef}
        // projectsRef={projectsRef}
      />
      <Second aboutmeRef={aboutmeRef} />
      <Third educationRef={educationRef} />
      <Fourth experiencesRef={experiencesRef} />
      <Fifth />
      <Eighth papersRef={papersRef} />
      {/* <Sixth projectsRef={projectsRef} /> */}
      <Seventh />
    </div>
  );
}

export default App;
